import { useMemo } from "react";
import { useColumns as useTimesheetColumns } from "../../../../TimeSheet/components/TimeSheetTable/useColumns";
import { useCustomFields } from "../../../CustomFields/context";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import { useAllowedColumns } from "../hooks/useAllowedColumns";

export const useHiddenColumns = () => {
    const { groups } = useGroups();
    const { timesheetCustomFields } = useCustomFields();

    return useMemo(() => [
        "status",
        "job",
        "location",
        "scheduled-amount",
        "payCode.description",
        "pbjCode",
        ...groups.reduce((total, { allocatedBy, level }) => {
            if (!allocatedBy) {
                return total.concat(level.replace("_", ""));
            }
            return total;
        }, []),
        ...timesheetCustomFields
            .filter(({ showByDefault }) => !showByDefault)
            .map(({ code }) => `customFields.${code}`),
    ], [timesheetCustomFields, groups]);
}

export const useColumns = () => {
    const columns = useTimesheetColumns({ user: undefined, canViewRates: true });
    return useAllowedColumns(columns);
}
